<template>
  <div class="analyze-relation">
    <div class="analyze-relation-row">
      <el-form
        :style="{
          'text-align': 'left',
        }"
        size="mini"
        inline
        label-width="100px"
        @keyup.enter.native="renderChart"
      >
        <el-form-item label="拓扑模式：">
         <el-select v-model="topologyModel">
           <el-option
              v-for="(value, label) in TOPOLOGY_MODEL"
              :key="value"
              :label="label"
              :value="value"/>
          </el-select>
        </el-form-item>

        <el-form-item label="拓扑关系：">
         <el-select v-model="topologyRelation">
            <el-option label="全部" value="" />
             <el-option
              v-for="(value, label) in TOPOLOGY_RELATION"
              :key="value"
              :label="label"
              :value="value"/>
          </el-select>
        </el-form-item>

        <el-form-item label="时间：">
           <el-date-picker
            class="analyze-relation-range"
            v-model="range"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            :disabled="loading"
            :unlink-panels="true"
            :default-time="['00:00:00', '23:59:59']"
            end-placeholder="结束日期"
            :clearable="false"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
            <el-button
            icon="el-icon-search"
            type="primary"
            @click="renderChart()"
          >查询</el-button>
           <el-button @click="reset()">重置</el-button>
        </el-form-item>

    </el-form>
      <div class="analyze-relation-tabs">
        <el-button
          v-for="item in topologyTypeList"
          :key="item.code"
          size="mini"
          :disabled="loading"
          :type="targetTopologyType === item.code ? 'primary' : ''"
          class="analyze-relation-tabs-item"
          @click="handleChangeTargetTopologyType(item.code)"
          >{{ item.name }}</el-button
        >
      </div>
    </div>

    <div class="analyze-relation-chart" v-loading="loading">
      <div class="analyze-relation-container" ref="container"></div>
      <div v-if="isEmpty" class="analyze-relation-empty">暂无相关数据</div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import { mapGetters } from 'vuex';
import { DataSet, Network } from 'vis';
import 'vis/dist/vis.min.css';
import moment from 'moment';
import { queryTopologyInfo } from '@/api/analyze';
import { TOPOLOGY_MODEL, TOPOLOGY_RELATION } from '../enums';

export default {
  data() {
    return {
      TOPOLOGY_RELATION,
      TOPOLOGY_MODEL,
      network: null,
      selected: 1,
      range: [], // 区域内容
      serverNameMap: {},
      isEmpty: false,
      targetTopologyType: '',
      topologyModel: TOPOLOGY_MODEL.标准模式,
      topologyRelation: '',
      loading: false,
      day6: 6 * 24 * 3600 * 1000,
      pickerOptions: {
        onPick: ({ minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (date) => {
          if (this.pickerMinDate) {
            const time = date.getTime();
            return time > this.pickerMinDate + this.day6 || time < this.pickerMinDate - this.day6;
          }
          return false;
        },
      },
    };
  },
  computed: {
    ...mapGetters('app', ['env', 'serverName', 'topologyTypeList']),
  },
  watch: {
    env() {
      this.renderChart();
    },
    serverName() {
      this.renderChart();
    },
  },
  methods: {
    /**
     * 选择类型
     */
    handleChangeSelected(index) {
      this.selected = this.tabs[index].value;
    },
    /**
     * 创建关系图
     */
    createNetwork(nodes = [], edges = []) {
      const data = {
        nodes,
        edges,
      };

      const options = {
        physics: {
          stabilization: false,
          barnesHut: {
            springLength: 200,
          },
        },
        nodes: {
          shape: 'circle', // 节点的外观。为circle时label显示在节点内，为dot时label显示在节点下方
        },
        interaction: {
          hover: true,
          tooltipDelay: 300,
        },
        edges: {
          width: 1,
          length: 500,
          color: {
            color: '#848499',
            highlight: 'rgb(117, 218, 167)',
            hover: '#88dab1',
            inherit: 'from',
            opacity: 1.0,
          },
          arrows: { to: true },
        },
      };

      const { container } = this.$refs;
      this.network = new Network(container, data, options);

      this.network.on('hoverNode', () => {
        // data.nodes.update({id: e.node, label: this.serverNameMap[e.node].full})
      });
      this.network.on('blurNode', () => {
        //  data.nodes.update({id: e.node, label: this.serverNameMap[e.node].ellipsis})
      });
    },
    /**
     * 设置默认的时间周期
     */
    setDefaultRange() {
      const startTime = `${moment().format('YYYY/MM/DD')} 00:00:00`;
      const endTime = `${moment().format('YYYY/MM/DD')} 23:59:59`;
      this.range = [new Date(startTime), new Date(endTime)];
    },
    /**
     * 设置节点的颜色
     */
    setNodesColor() {},
    /**
     * 设置最大的字体
     */
    ellipsisText(text) {
      if (!text) {
        return '未知服务';
      }
      return text.length > 5 ? `${text.substr(0, 5)}...` : text;
    },
    /**
     * 创建节点
     */
    createNodes(data) {
      console.log(data);
      const { topologyInfos } = data;
      const nodes = [];
      const edges = [];
      const edgeMap = {};
      const nodeMap = {};

      if (topologyInfos.length > 0) {
        const createNodes = (item) => {
          const { serverName, serverType } = item;
          return `${serverName}_${serverType}`;
        };

        topologyInfos.forEach((item) => {
          nodeMap[createNodes(item)] = item;

          if (item.targetTopologyInfos.length > 0) {
            item.targetTopologyInfos.forEach((subItem) => {
              nodeMap[createNodes(subItem)] = subItem;
              const key = `${createNodes(item)}_${createNodes(subItem)}`;
              const edgeItem = {
                from: createNodes(item),
                to: createNodes(subItem),
                label: subItem.topologyType,
                topologyType: subItem.topologyType,
              };

              if (!edgeMap[key]) {
                edgeMap[key] = edgeItem;
                edges.push(edgeItem);
              } else {
                console.log(edgeMap[key].topologyType, subItem.topologyType, subItem.serverName);
                if (edgeMap[key].topologyType !== subItem.topologyType) {
                  edges.push(edgeItem);
                }
              }
            });
          }
        });

        for (const key in nodeMap) {
          const nodeItem = nodeMap[key];
          const { serverName, internalFlag } = nodeItem;
          nodes.push({
            id: key,
            font: { multi: 'html' },
            // label: `${nodeMap[key].serverName}\n<b>${nodeMap[key].topologyAddress || ''}</b>`
            label: `${this.ellipsisText(serverName)}`,
            title: `${serverName}`,
            color: internalFlag ? null : {
              border: 'red',
              background: '#ff6352',
              highlight: {
                border: 'red',
                background: 'rgb(255, 115, 115)',
              },
              hover: {
                border: 'red',
                background: 'rgb(255, 115, 115)',
              },
            },
          });
        }
      }
      return {
        nodes,
        edges,
      };
    },
    /**
     * 查询拓扑关系
     */
    async queryTopologyInfo() {
      const [
        // eslint-disable-next-line no-underscore-dangle
        analyzeTimeFrom = moment().subtract(6, 'days')._d,
        // eslint-disable-next-line no-underscore-dangle
        analyzeTimeTo = moment()._d,
      ] = this.range;
      const params = {
        targetTopologyType: this.targetTopologyType,
        topologyModel: this.topologyModel, // STANDARD：标准模式 SIMPLE：简单模式
        topologyRelation: this.topologyRelation, // PUB：发起方 SUB：接收方
      };
      console.log(analyzeTimeFrom, analyzeTimeTo);
      if (analyzeTimeFrom && analyzeTimeTo) {
        params.analyzeTimeFrom = moment(analyzeTimeFrom).format('YYYY-MM-DD HH:mm:ss');
        params.analyzeTimeTo = moment(analyzeTimeTo).format('YYYY-MM-DD HH:mm:ss');
      }

      const res = await queryTopologyInfo(params);
      const { data } = res;
      return data;
    },
    /**
     * 切换类型
     */
    handleChangeTargetTopologyType(value) {
      this.targetTopologyType = value;
      this.renderChart();
    },
    /**
     * 渲染图表
     */
    async renderChart() {
      this.$nextTick(async () => {
        this.loading = true;
        const data = await this.queryTopologyInfo().catch(() => {
          this.loading = false;
        });
        const { nodes: nodesData, edges: edgesData } = this.createNodes(data);

        const nodes = new DataSet(nodesData);
        const edges = new DataSet(edgesData);
        this.createNetwork(nodes, edges);
        this.isEmpty = nodesData.length === 0 && edgesData.length === 0;
        this.loading = false;
      });
    },
    reset() {
      Object.assign(this.$data, this.$options.data());
      this.setDefaultRange();
      this.renderChart();
    },
  },
  mounted() {
    this.setDefaultRange();
    this.renderChart();
  },
};
</script>
<style lang="scss">
.el-picker-panel__footer .el-picker-panel__link-btn.el-button--text {
  display: none;
}
</style>
<style scoped lang="scss">
.analyze-relation {
  &-row {
    // display: flex;
    // align-items: center;
    // justify-content: flex-end;
    padding: 15px 20px;
  }

  &-tabs {
    text-align: left;
    flex: 1;

    &-item {
      margin-bottom: 5px;
    }
  }

  &-text {
    color: #333;
    cursor: pointer;

    &:hover {
      color: #2d8cf0;
    }

    &.is-active {
      color: #2d8cf0;
    }
  }

  &-chart {
    padding: 0 20px;
    margin-bottom: 20px;
    position: relative;
  }

  &-container {
    height: calc(100vh - 205px);
    background: #fff;
  }

  &-empty {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 30%;
    color: #ccc;
    font-size: 14px;
  }
}
</style>

function moment() { throw new Error('Function not implemented.'); }
